import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import {
  getRhiRouteParamsFromPathname,
  getRhiStepFromPathname,
  resolveRhiRoute,
  RHI_STEP_ORDER,
  useRhiFlowStore,
  type RhiStep,
} from '@/store/rhiFlowStore';

const isGuardedStep = (step: RhiStep) => RHI_STEP_ORDER.includes(step);

const RhiFlowGuard = () => {
  const location = useLocation();
  const goTo = useRhiFlowStore((state) => state.goTo);
  const canBeAt = useRhiFlowStore((state) => state.canBeAt);
  const resume = useRhiFlowStore((state) => state.resume);

  const routeStep = getRhiStepFromPathname(location.pathname);
  const routeParams = getRhiRouteParamsFromPathname(location.pathname);

  useEffect(() => {
    if (!routeStep) return;
    if (!isGuardedStep(routeStep)) return;
    if (!canBeAt(routeStep)) return;

    goTo(routeStep);
  }, [canBeAt, goTo, routeStep]);

  if (!routeStep || !isGuardedStep(routeStep)) {
    return <Outlet />;
  }

  if (!canBeAt(routeStep)) {
    const fallbackStep = resume(routeStep);

    return (
      <Navigate
        replace
        to={resolveRhiRoute(fallbackStep, routeParams)}
      />
    );
  }

  return <Outlet />;
};

export default RhiFlowGuard;
